module.exports = __webpack_public_path__ + "img/notification-sidebar-act.a038a477.svg";